import { Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DeliveryListPage from './pages/DeliveryListPage';
import SignPage from './pages/SignPage';
import { getToken } from './api';

function RequireAuth({ children }: { children: JSX.Element }): JSX.Element {
  return getToken() ? children : <Navigate to="/login" replace />;
}

export default function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<RequireAuth><DeliveryListPage /></RequireAuth>} />
      <Route path="/sign/:id" element={<RequireAuth><SignPage /></RequireAuth>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
